import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, DialogContent, TextField } from "@material-ui/core";
import { HexColorPicker } from "react-colorful";
import { makeStyles } from "@material-ui/core/styles";
import "../categories/Categories.scss";

const useStyles = makeStyles({
  paperFullWidth: {
    overflowY: "visible",
    maxWidth: 300,
  },
  dialogContentRoot: {
    overflowY: "visible",
  },
});

export default function CategoriesView({ data, handleClose }) {
  const classes = useStyles();

  return (
    <>
      <DialogTitle id="form-dialog-title">Detalle de Categoría</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          id="name"
          label="Nombre"
          type="text"
          name="nombre"
          defaultValue={data.name}
          InputProps={{
            readOnly: true,
          }}
          fullWidth
        />
      </DialogContent>
      <DialogContent
        classes={{
          root: classes.dialogContentRoot,
        }}>
        <section className="small example">
          <HexColorPicker
            color={data.color}
            onChange={() => {}}
            style={{ pointerEvents: "none", cursor: "default" }}
          />
          <div className="value" style={{ borderLeftColor: data.color }}>
            Color: {data.color}
          </div>
        </section>
      </DialogContent>
      <DialogContent
        classes={{
          root: classes.dialogContentRoot,
        }}
        style={{ maxWidth: 300 }}>
        <TextField
          autoFocus
          margin="dense"
          id="company"
          label="Compañía"
          type="text"
          name="compañia"
          defaultValue={data.company[0].label}
          InputProps={{
            readOnly: true,
          }}
          fullWidth
        />
      </DialogContent>
      {data.urlImage && (
        <DialogContent>
          <p>
            <a href={data.urlImage} target="_blank">
              Ver Imagen
            </a>
          </p>
        </DialogContent>
      )}
      <DialogContent>
        <TextField
          id="externalCategory"
          label="Categoría externa"
          type="text"
          name="categoriaExterna"
          defaultValue={data.externalCategory}
          InputProps={{
            readOnly: true,
          }}
          fullWidth
        />
      </DialogContent>
      <DialogContent>
        <Button
          className="c-ml-5 c-grid-btn"
          color="primary"
          onClick={handleClose}>
          Cerrar
        </Button>
      </DialogContent>
    </>
  );
}
